// Import Firebase SDK
import { initializeApp } from "https://www.gstatic.com/firebasejs/11.0.1/firebase-app.js";
import {
  getDatabase,
  ref,
  onValue,
  set,
  serverTimestamp,
  onDisconnect
} from "https://www.gstatic.com/firebasejs/11.0.1/firebase-database.js";

document.addEventListener("DOMContentLoaded", function() {

  // === Firebase Config ===
  const firebaseConfig = {
    apiKey: "AIzaSyDhkJBck52oiMKN34eDoSSbqy0J1HWI1bI",
    authDomain: "hawthorne-live-viewers.firebaseapp.com",
    databaseURL: "https://hawthorne-live-viewers-default-rtdb.firebaseio.com/",
    projectId: "hawthorne-live-viewers",
    storageBucket: "hawthorne-live-viewers.firebasestorage.app",
    messagingSenderId: "364887433447",
    appId: "1:364887433447:web:a0231102a9feda9cfc4242"
  };

  // === Initialize Firebase ===
  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);
  console.log("Firebase initialized");

  // === Get product handle from data attribute ===
  const productElement = document.querySelector("[data-product-handle]");
  if (!productElement) {
    console.warn("No data-product-handle attribute found. Live tracker not initialized.");
    return;
  }

  const productHandle = productElement.dataset.productHandle;
  console.log("Product Handle:", productHandle);

  // === Generate a unique viewer ID per visitor ===
  const viewerId = Math.random().toString(36).substring(2, 10);
  console.log("Viewer ID:", viewerId);

  const viewersRef = ref(db, "viewers/" + productHandle + "/" + viewerId);
  const counterRef = ref(db, "viewers/" + productHandle);

  // === Add visitor to Firebase ===
  set(viewersRef, { time: serverTimestamp() })
    .then(() => console.log("Added viewer to Firebase"))
    .catch((err) => console.error("Error adding viewer:", err));

  // === Remove visitor on disconnect ===
  onDisconnect(viewersRef)
    .remove()
    .then(() => console.log("Will remove viewer on disconnect"))
    .catch((err) => console.error("Disconnect error:", err));

  // === Get all live_count elements ===
  const liveCountEls = document.querySelectorAll(".live_count");
  if (!liveCountEls.length) {
    console.warn("No .live_count elements found on page");
  }

  // === Real-time listener for live count ===
  onValue(counterRef, (snapshot) => {
    const data = snapshot.val() || {};
    const count = Object.keys(data).length;

    if (!liveCountEls.length) return;

    // Update all .live_count elements
    liveCountEls.forEach((el) => {
      const previousContent = el.innerHTML ? el.innerHTML.trim() : "";

      // Only update if previous content exists
      if (previousContent !== "") {
        el.innerHTML = count;
      }
    });

    console.log("Current live viewers:", count);
  });

});
